import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderGradient } from '@components/ui/header-gradient/header-gradient';
import { Logo } from '@components/ui/logo/logo';
import { RouterModule } from '@angular/router';
import { Brand } from '@components/ui/brand/brand';
import { FormsModule } from '@angular/forms';
import { CommingSoon } from '@components/ui/comming-soon/comming-soon';
import { RadialProgress } from '@components/ui/radial-progress/radial-progress';
import { ClassOnScroll } from './directives/class-on-scroll';
import { Phone } from './phone/phone';


@NgModule({
  declarations: [
    HeaderGradient,
    Logo,
    Brand,
    CommingSoon,
    RadialProgress,
    ClassOnScroll,
    Phone
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule
  ],
  exports: [
    HeaderGradient,
    Logo,
    Brand,
    CommingSoon,
    RadialProgress,
    ClassOnScroll,
    Phone
  ]
})
export class UiModule { }
